<script setup lang="ts">
import { ComponentWrapperImageProps } from "./ComponentWrapperImage.props"
defineProps<ComponentWrapperImageProps>()
</script>

<template>
  <div class="padded py-5 md:py-10">
    <div v-if="desktopImage" class="hidden md:block">
      <UtilsWrapperImage
        v-bind="desktopImage"
        :preload="true"
        :img-attrs="{ fetchpriority: 'high' }"
        sizes="lg:90vw"
      />
    </div>
    <div v-if="mobileImage" class="block md:hidden">
      <UtilsWrapperImage
        v-bind="mobileImage"
        :preload="true"
        :img-attrs="{ fetchpriority: 'width' }"
        sizes="100vw, sm:100vw"
      />
    </div>
  </div>
</template>
